// extracted by mini-css-extract-plugin
module.exports = {"searchContent":"kH","content":"kI","navigation":"kJ","mainPanel":"kK","footer":"kL"};